import React__default from 'react';

var Currency = function (_a) {
  var amount = _a.amount,
    _b = _a.includeFraction,
    includeFraction = _b === void 0 ? false : _b,
    _c = _a.superFraction,
    superFraction = _c === void 0 ? true : _c;
  var formatter = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD"
  });
  var _d = formatter.format(amount).split("."),
    wholeAmount = _d[0],
    fractionAmount = _d[1];
  var shouldIncludeFraction = includeFraction && fractionAmount !== "00";
  var fraction = function () {
    if (!shouldIncludeFraction) return null;
    if (superFraction) return React__default.createElement("sup", null, ".", fractionAmount);
    return ".".concat(fractionAmount);
  };
  return React__default.createElement(React__default.Fragment, null, wholeAmount, fraction());
};

export { Currency };
//# sourceMappingURL=Currency.js.map
